module.exports = __webpack_public_path__ + "static/media/TEMPLATE.0b730ebc.csv";